import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between mb-6 animate-fade-up" data-testid={testId}>
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}

export function YesNoBadge({ value, yes = "Yes", no = "No", testId }) {
  return (
    <span data-testid={testId}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold border ${value ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-slate-100 text-slate-500 border-slate-200"}`}>
      {value ? yes : no}
    </span>
  );
}

export function Pagination({ page, pageSize, total, setPage, testId = "pagination" }) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  return (
    <div className="flex items-center justify-between text-sm text-slate-500 mt-4" data-testid={testId}>
      <span data-testid={`${testId}-total`}>{total} record{total === 1 ? "" : "s"}</span>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => setPage(page - 1)} data-testid={`${testId}-prev`}>Previous</Button>
        <span>Page {page} of {pages}</span>
        <Button variant="outline" size="sm" disabled={page >= pages} onClick={() => setPage(page + 1)} data-testid={`${testId}-next`}>Next</Button>
      </div>
    </div>
  );
}

export function Spinner({ className = "" }) {
  return <Loader2 className={`h-4 w-4 animate-spin ${className}`} />;
}
